import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MemberResponse } from './types';

export async function getMember(memberId: string) {
  const url = `/web/studio/users/${memberId}`;

  const response = await api.executeGetRequest<ObjectResponse<MemberResponse>>(url);

  return response.data;
}
